import React from 'react';
import styled from '@emotion/styled';

export const ProjectsGrid = ({ children }) => <Grid>{children}</Grid>;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  gap: 16px;
`;
